import { ITool, ToolCategory, TOOL_CATEGORIES } from '@/creditflowresearch/domain/vo/ITools';
import { TOOL_CONFIG } from '@/creditflowresearch/domain/Header/Tool/config';

export type ToolClassifierFn = (tool: ITool) => ToolCategory | null;

class ToolClassifier {
  private static readonly CLASSIFIERS: ToolClassifierFn[] = [
    (tool) =>
      ToolClassifier.isMarketOverviewTool(tool.id)
        ? TOOL_CATEGORIES.MARKET_OVERVIEW
        : null,
    () => TOOL_CATEGORIES.REGULAR,
  ];

  static classify(tool: ITool): ToolCategory {
    const category = ToolClassifier.CLASSIFIERS
      .map((classifier) => classifier(tool))
      .find((result) => result !== null);

    return (category || TOOL_CATEGORIES.REGULAR) as ToolCategory;
  }

  static isMarketOverviewTool(toolId: string): boolean {
    return (TOOL_CONFIG.marketOverviewToolIds as readonly string[]).includes(toolId);
  }

  static getMarketOverviewToolIds(): string[] {
    return [...TOOL_CONFIG.marketOverviewToolIds];
  }

  static registerClassifier(classifier: ToolClassifierFn): void {
    ToolClassifier.CLASSIFIERS.push(classifier);
  }
}

export default ToolClassifier;
